import { render, staticRenderFns } from "./LongMsgPopper.vue?vue&type=template&id=2d4b4ae6&"
import script from "./LongMsgPopper.vue?vue&type=script&lang=js&"
export * from "./LongMsgPopper.vue?vue&type=script&lang=js&"
import style0 from "./LongMsgPopper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports